import { getApiClient } from '../services/api';

export interface InviteInfoItem {
  id: number;
  accept_read: boolean; // 被邀请人是否已读
  invitation_read: boolean; // 邀请人是否已读
  accept_total_credit_coins: number; // 被邀请人奖励
  invitation_total_credit_coins: number; // 邀请人奖励
  goon_behavior_type: 1 | 2 | 3; // 1-完成注册 2-升级个人版月套餐 3-升级个人版年套餐
}

export interface InviteInfoParams {
  page?: number;
  page_size?: number;
  many: boolean;
  is_invitee?: number; // 0=被邀人，1=邀请人
  invitation_read?: number; // 邀请人是否已读，0=未读，1=已读
  accept_read?: number; // 被请人是否已读，0=未读，1=已读
  goon_behavior_type?: any[];
  use_cache?: string;
}

export enum INVITE_RECORD_TYPE {
  REGISTER = 1, // 注册
  MONTH = 2, // 个人月套餐
  YEAR = 3, // 个人年套餐
}

// 拉新记录
export const getInviteRecordInfo = async (params: InviteInfoParams) => {
  const client = await getApiClient();
  return client.get<InviteInfoItem[]>('/attraction/record/', params);
};

// 已读记录
export const readRecordType = async (is_invitee: number, params: { record_id: number }) => {
  const client = await getApiClient();
  return client.post<InviteInfoItem>(`/attraction/record/read/?is_invitee=${is_invitee}`, params);
};
